export default "__VITE_ASSET__DZF_kpjs__"